import {
  type AxiosRequestConfig,
  type GeocodeReverseData,
  formatFeatureToAddress,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';
import { publicEnv } from '@/config/public-env.config.mjs';

// Cùng gw-maps gateway với autocomplete và batch_geocode. Đã đối chiếu:
// response của `/wgeo/v2/reverse` trên gw-maps giống hệt EP (byte-for-byte, cả
// stg lẫn prod). Gateway public, không cần api-key — KHÔNG gửi `x-api-key`
// (không nằm trong allow-headers của gateway → preflight fail).
const MAPS_BASE_URL = publicEnv.NEXT_PUBLIC_EP_API_URI.replace(/\/+$/, '');

const REVERSE_URL = `${MAPS_BASE_URL}${apiRoutes.place.geocode_reverse}`;

export type GeocodeReverseParams = {
  lng: number;
  lat: number;
  profile?: string;
  'boundary.country'?: string;
  'boundary.circle.radius'?: string;
};

export const getGeocodeReverseFn = async (
  params: GeocodeReverseParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await publicHttpClient.get<GeocodeReverseData>(REVERSE_URL, {
    params: {
      profile: 'ahamove',
      'boundary.country': 'VN',
      'boundary.circle.radius': '2000',
      ...params,
    },
    ...config,
  });

  return formatFeatureToAddress(response.data.data);
};
